.item {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-0_5, 4px);
  padding: var(--tuna-spacing-1, 8px) var(--tuna-spacing-1_5, 12px);
  border-bottom: 1px solid var(--tuna-palette-divider, rgba(0, 0, 0, 0.06));
}

.item:last-child {
  border-bottom: 0;
}

.summary {
  font-size: 14px;
}

.summary--destructive {
  color: var(--tuna-palette-error-main, #d32f2f);
}

.target {
  color: var(--tuna-palette-text-secondary, rgba(0, 0, 0, 0.6));
}

.actions {
  display: flex;
  gap: var(--tuna-spacing-0_5, 4px);
  margin-top: var(--tuna-spacing-0_5, 4px);
}
